import { formatCurrency } from 'common/FormatUtilities';
import React, { useEffect, useRef } from 'react';
import { DishFirstQuickAdd } from 'src/shared/design-system/DishFirstCard/DishFirstQuickAdd';
import { RatingChip } from 'src/shared/design-system/DishFirstCard/RatingChip';
import { ChipContainer } from 'src/shared/design-system/DishFirstCard/styles';
import { CuisineListing, FoodName, Price } from 'src/shared/design-system/DishFirstDishCard/styles';
import { DynamicImage } from 'src/shared/design-system/DynamicImage';
import styled from 'styled-components';
import { BorderRadius } from 'web-common/src/shared/styles';
import { DishFirstCardLandscape } from '../DishFirstCard';
import { getTopKCuisines } from '../DishFirstCard/utils';
import { DishCardProps } from './types';

// Not all dish first cards on mobile are landscape, segment rows side scroll with portrait cards

const IMAGE_SIZE = 142;

const FoodImage = styled(DynamicImage)`
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: ${BorderRadius.M} 0 0 ${BorderRadius.M};
`;

// NOTE: This should be renamed to DishCard if/when we remove the legacy explore page
export const DishFirstDishCardLandscape: React.FC<DishCardProps> = (props) => {
  const {
    className,
    foodItemPreview,
    onClick,
    increment,
    decrement,
    quantity = 0,
    minQuantity = 0,
    maxQuantity = 0,
    quickAddLoading = false,
    quickAddError = false,
  } = props;
  const foodNameRef = React.useRef<HTMLSpanElement>(null);
  const foodNameTimeout = useRef(0);

  const cuisines = getTopKCuisines({ ...foodItemPreview });

  useEffect(
    () => () => {
      window.clearTimeout(foodNameTimeout.current);
    },
    []
  );

  // Just type-safety, this should not happen
  if (!foodItemPreview?.imageUrl || !foodItemPreview?.name) return null;

  const imageContent = (
    <>
      <FoodImage
        src={foodItemPreview.imageUrl}
        alt={foodItemPreview.name}
        sourceWidth={IMAGE_SIZE}
        sourceHeight={IMAGE_SIZE}
      />
      {foodItemPreview?.averageRating && (
        <ChipContainer bottom left>
          <RatingChip averageRating={foodItemPreview.averageRating} />
        </ChipContainer>
      )}
    </>
  );

  const bodyContent = (
    <>
      <CuisineListing>{cuisines}</CuisineListing>
      <FoodName ref={foodNameRef}>{foodItemPreview.name}</FoodName>
    </>
  );

  const footerContent = (
    <>
      <Price>{formatCurrency(foodItemPreview.price)}</Price>
      <DishFirstQuickAdd
        increment={increment}
        decrement={decrement}
        quantity={quantity}
        minQuantity={minQuantity}
        maxQuantity={maxQuantity}
        loading={quickAddLoading}
        error={quickAddError}
      />
    </>
  );

  return (
    <DishFirstCardLandscape
      onClick={onClick}
      className={className}
      imageContent={imageContent}
      bodyContent={bodyContent}
      footerContent={footerContent}
    />
  );
};
